import { render } from "./packagesList.vue?vue&type=template&id=75e50b8f"
import script from "./packagesList.vue?vue&type=script&lang=js"
export * from "./packagesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__